module.exports = __webpack_public_path__ + "img/write.50a61eba.png";